import { billing, plans } from '@saucelabs/sl-util-axios';

import { ServerSubscription } from '../../records/Subscription';
import { AutoTopUpToggleStatus } from '../../records/Plan';

export const retrieveSubscriptions = () => (
  billing.get<ServerSubscription[]>('/subscriptions')
);

export const cancelSubscription = (id: string) => (
  billing.delete<ServerSubscription>(`/subscriptions/${id}`)
);

export const setAutoTopup = (params: AutoTopUpToggleStatus): AsyncResponse<void> => plans.put('/auto_topup_toggle', params);
export const getAutoTopup = (): AsyncResponse<AutoTopUpToggleStatus> => plans.get('/auto_topup_toggle');
